import packageInfo from '../../../package.json'
import dayjs from 'dayjs'
import { Notification } from 'element-ui'
import refreshMessage from '@/plugins/updateCheck/components/refreshMessage'
import Vue from 'vue'
const isNewVersionMessage = '有新功能上线，建议刷新页面获得更好的使用体验'
const noOperateCheckMessage = '你在系统停留时间较长，建议刷新页面获得更好的使用体验'
const markTip = '获取是否需要刷新失败！！'
const newVersionTip = '有发布，版本更新检验报错！！'
const noOperateCheckTip = '八小时未操作校验报错！！'
const needRemindCheckTip = '刷新弹窗中选择了稍后提示校验报错！'

let timer
let remindNote

export function beforeAppCreate() {
  try {
    if (window.self === window.top) {
      timer = setInterval(() => {
        checkNeedFresh()
      }, 60 * 1000)
    }
  } catch (e) {
    console.log(markTip, e)
  }
}

function destroy(e) {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  window.removeEventListener('beforeunload', destroy)
  // e.preventDefault()
  // e.returnValue = true
}
window.addEventListener('beforeunload', destroy)

export async function checkNeedFresh() {
  try {
    // 1、有发布，版本更新，需要弹窗提示用户刷新
    const isNewVersion = await checkNewVersion()
    // 2、八小时未操作，需要弹窗提示用户刷新
    const noOperateCheck = checkNoOperate()
    // 3、刷新弹窗中选择了稍后提示，需要弹窗提示用户刷新
    const needRemindCheck = checkNeedRemindCheck()
    if (isNewVersion || noOperateCheck || needRemindCheck) {
      refreshHandler(isNewVersion ? isNewVersionMessage : noOperateCheckMessage)
      clearInterval(timer)
    }
  } catch (e) {
    console.log(e)
  }
}

export async function checkNewVersion() {
  try {
    if (process?.env?.VUE_APP_STATUS !== 'prod') {
      return false
    }
    if (+window?.NEW_CALL_CENTER_REMIND_MARK_TIME && +window?.NEW_CALL_CENTER_REMIND_LATER_TIME) {
      return false
    }
    const pjInfoHostname = _.get(window, 'location.hostname', '')
    const windowPathname = _.get(window, 'location.pathname', '')
    const versionPjInfo = `https://${pjInfoHostname}${windowPathname}pj_info.json`
    const newVersionPjInfo = await fetch(`${versionPjInfo}?${+dayjs()}`)
      .then(res => {
        return res.json()
      })
      .catch(() => {
        return {}
      })
    const newVersionNumber = newVersionPjInfo?.version || ''
    const newVersionOperationTime = newVersionPjInfo?.operation_time ? dayjs(newVersionPjInfo?.operation_time) : dayjs()
    const nowDiffNewVersionOperationTime = dayjs().diff(newVersionOperationTime, 'hour', true)
    const oldVersionNumber = packageInfo?.version || ''
    console.log('oldVersionNumber', oldVersionNumber)
    console.log('newVersionNumber', newVersionNumber)
    if (!oldVersionNumber || !newVersionNumber) {
      return false
    }
    return oldVersionNumber !== newVersionNumber && nowDiffNewVersionOperationTime >= 1
  } catch (e) {
    console.log(newVersionTip, e)
    return false
  }
}

export function checkNoOperate() {
  try {
    if (+window?.NEW_CALL_CENTER_REMIND_MARK_TIME && +window?.NEW_CALL_CENTER_REMIND_LATER_TIME) {
      return false
    }
    const createdTime = _.get(performance, 'timing.navigationStart', 0)
    const nowDiffCreatedTime = dayjs().diff(dayjs(createdTime), 'hour', true)
    return !!(createdTime && nowDiffCreatedTime >= 8)
  } catch (e) {
    console.log(noOperateCheckTip, e)
    return false
  }
}

export function checkNeedRemindCheck() {
  try {
    if (!+window?.NEW_CALL_CENTER_REMIND_MARK_TIME || !+window?.NEW_CALL_CENTER_REMIND_LATER_TIME) {
      return false
    }
    const nowDiffRemindMarkTime = dayjs().diff(dayjs(+window?.NEW_CALL_CENTER_REMIND_MARK_TIME), 'minute', true)
    return nowDiffRemindMarkTime >= +window?.NEW_CALL_CENTER_REMIND_LATER_TIME
  } catch (e) {
    console.log(needRemindCheckTip, e)
    return false
  }
}

export function refreshHandler(message = '') {
  try {
    let tipInstance = new Vue({
      render: h =>
        h(refreshMessage, {
          props: {
            remindNote,
            alertMessage: message,
            beforeAppCreate
          },
          on: {
            remindClose: time => {
              remindNote?.close()
              window.NEW_CALL_CENTER_REMIND_MARK_TIME = +dayjs()
              window.NEW_CALL_CENTER_REMIND_LATER_TIME = time
            }
          }
        })
    }).$mount()
    remindNote = Notification({
      title: '系统更新',
      showClose: true,
      dangerouslyUseHTMLString: true,
      message: tipInstance?._vnode,
      iconClass: 'el-icon-warning warning-icon-refresh',
      showCancelButton: false,
      showConfirmButton: false,
      duration: 0,
      onClose: () => {
        window.NEW_CALL_CENTER_REMIND_MARK_TIME = +dayjs()
        window.NEW_CALL_CENTER_REMIND_LATER_TIME = 5
        beforeAppCreate()
        tipInstance?.$destroy?.()
        tipInstance = null
      }
    })
  } catch (e) {
    console.log(markTip, e)
  }
}
